import React, { ReactNode } from "react";
import { Box } from "rizzui/box";
import { Text } from "rizzui/typography";
import RingConnect from "../assets/ringconnect";
export default function AccountBox({
  children,
  isLogin,
}: {
  children: ReactNode;
  isLogin?: boolean;
}) {
  return (
    <div className="min-h-lvh h-full w-full flex flex-row justify-center items-center bg-background">
      <div className="h-full w-[96%] md:w-[379px] flex flex-row justify-center place-items-center py-[32px]">
        <div className="h-full flex flex-col gap-[32px] ">
          <Box className="flex flex-col gap-[16px] justify-center items-center relative">
            <RingConnect className="h-[31px] w-[205px]" />
            {isLogin && (
              <Text className="text-center leading-[18.48px] text-[14px] text-secondary-dark font-switzer">
                Have an account?{" "}
                <a href="login" className="font-semibold underline">
                  Log In
                </a>
              </Text>
            )}
          </Box>
          <Box className="border-[.5px] border-muted rounded-sm h-auto w-full bg-foreground p-[32px] relative">
            {children}
          </Box>
        </div>
      </div>
    </div>
  );
}
